"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Image_1 = require("../../template/Image");
var Button_1 = require("../Button");
var CommonInput_1 = require("../CommonInput");
var AddressSummary = function (_a) {
    var address = _a.address, handleEnterManually = _a.handleEnterManually, clearAddress = _a.clearAddress, removeAddressIcon = _a.removeAddressIcon, label = _a.label, errors = _a.errors;
    var fields = ['house_name', 'flat', 'house_number', 'street', 'town', 'postcode'];
    var summary = fields.map(function (key) {
        if (address[key]) {
            return address[key];
        }
        return false;
    }).filter(function (item) { return (item !== false); });
    var addressErrors = typeof errors === 'string' ? errors : undefined;
    return (React.createElement(CommonInput_1.default, { label: label, errors: addressErrors },
        React.createElement("div", { className: 'summary-wrapper' },
            React.createElement("div", { className: 'summary-container' },
                React.createElement(Button_1.default, { className: 'summary unstyled', handleClick: handleEnterManually }, summary.join(', ')),
                React.createElement(Button_1.default, { className: 'clear unstyled', handleClick: clearAddress },
                    React.createElement("i", null,
                        React.createElement(Image_1.default, { altText: 'Remove address', src: removeAddressIcon })))))));
};
exports.default = AddressSummary;
